import Example from './Example';
import LoadUserData from '../../LoadUserData';

export const ExampleConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['admin','super'],
    routes  : [
        {
            path     : '/example',
            component: LoadUserData(Example)
        }
    ]
};
